import { render, staticRenderFns } from "./StartWorkflowAttributeForm.vue?vue&type=template&id=6ba7a573&scoped=true&"
import script from "./StartWorkflowAttributeForm.vue?vue&type=script&lang=js&"
export * from "./StartWorkflowAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./StartWorkflowAttributeForm.vue?vue&type=style&index=0&id=6ba7a573&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7a573",
  null
  
)

export default component.exports